(function() {
    'use strict';

a3_pilot_reports.directive('flexCombination',FlexCombination);

    
    
   /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name FlexCombination
   * @restrict E
   * @description
   *   Implementation of Flex Combinations
   *
   *   Initialize the Flex Combination of a season
   * @example
   *   Usage:
   *   <flex-combination season-configuration="seasonConfiguration"  season-request="seasonRequest"></flex-combination>
   * @ngInject
   */    
function FlexCombination($timeout) {
    
    function link(scope, element, attrs){
        
     
        angular.forEach(scope.seasonRequest.LeaveRequestPriorityPeriods, function (value, key) {
            var temp = value.MockLeaveRequestPrioritySlots;
            var temp2 = value.LeaveRequestPrioritySlots;

            $timeout(function(){
                value.MockLeaveRequestPrioritySlots = angular.fromJson(temp);
                value.LeaveRequestPrioritySlots= angular.fromJson(temp2);
            })    
            
        });
        
        scope.sortableOptions = {
            handle: '>.row .myHandle',
            update: function(e, ui) {
            },
            stop: function(e, ui) {
                for(var i=0; i< scope.seasonRequest.LeaveRequestPriorityPeriods.length;i++){     
                        sortSetupOrderNo(scope.seasonRequest.LeaveRequestPriorityPeriods[i])
                }
            }
        };    
        
        
       
        scope.setupOrderNo = setupOrderNo;
            
        function sortSetupOrderNo(period){
            if(Array.isArray(period.LeaveRequestPrioritySlots)){
                for (var i=0; i<period.LeaveRequestPrioritySlots.length;i++ ){
                    period.LeaveRequestPrioritySlots[i].OrderNo =  i + 1;
                }
             }
        };
        
              
        function setupOrderNo(period){
            if(Array.isArray(period.MockLeaveRequestPrioritySlots)){
                period.LeaveRequestPrioritySlots = [];

                for (var i=0; i<period.MockLeaveRequestPrioritySlots.length;i++ ){
                    var temp = Object.assign({}, period.MockLeaveRequestPrioritySlots[i]);
                    temp.OrderNo =  i + 1;
                    period.LeaveRequestPrioritySlots.push(temp);   
                }
             }
        };
        
        
        
        scope.removeSlot = removeSlot;
        
        
        function removeSlot(slotIndex,period)
        {
            period.LeaveRequestPrioritySlotsHelper=[];
            
            for (var i=0; i<period.LeaveRequestPrioritySlots.length;i++ ){
                if(i!=slotIndex){
                    period.LeaveRequestPrioritySlotsHelper.push(period.LeaveRequestPrioritySlots[i]);
                }
            }
            period.LeaveRequestPrioritySlots = period.LeaveRequestPrioritySlotsHelper;
            period.MockLeaveRequestPrioritySlots = period.LeaveRequestPrioritySlotsHelper;

            setupOrderNo(period);
        }
    }
        
   return {
        restrict: 'E',
        terminal: true,
        templateUrl: 'views/LeaveRequest/flexCombinations.tpl.html',
        scope : {
            seasonConfiguration: '<',
            seasonRequest : '=',
            editable : '<'
        },
        link: link
    }
}

})();